import { getAllQueue, removeFromQueue } from "./offline_queue";
import { showPwaFlash } from "./show_pwa_flash";

let isSyncing = false

export async function syncQueue() {
    if (!navigator.onLine) return
    if (isSyncing) return

    isSyncing = true

    try {
        const queue = await getAllQueue()
        if (queue.length === 0) return
        let successCount = 0
        let failureCount = 0

        for (const item of queue) {
            try {
                const {url, method} = resolveEndpoint(item)
                if (!url) {
                    console.warn(`Unknown queue item type: ${item.type}`)
                    continue
                }

                const formData = buildFormData(item.payload, method)

                const response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.getAttribute("content"),
                        "Accept": "application/json"
                    },
                    body: formData
                })

                if (response.ok) {
                    await removeFromQueue(item.id)
                    successCount++

                    if (item.type === "clock_in" || item.type === "clock_out") {
                        localStorage.removeItem("selected_weather_id")
                    }
                } else {
                    console.warn(`Sync failed for item ${item.id}: ${response.status} — discarding, server data will be used`)
                    await removeFromQueue(item.id)
                    failureCount++
                }

            } catch (error) {
                console.warn("Sync paused — network unavailable")
                break
            }
        }

        if (successCount > 0) {
            showPwaFlash(`${successCount}出席状況が正常に保存されました`, "success")
        }
        if (failureCount > 0) {
            showPwaFlash(`${failureCount}件の保存に失敗しました。サーバーの内容で表示します。`, "alert")
        }

        if (successCount > 0 || failureCount > 0) {
            setTimeout(() => {
                window.dispatchEvent(new CustomEvent("pwa:before-sync-reload"))
                window.location.reload()
            }, 3000)
        }
    } finally {
        isSyncing = false
    }
}

function resolveEndpoint(item) {
    switch (item.type) {
        case "clock_in":
            return { url: "/attendances/clock_in", method: "POST" }
        case "clock_out":
            return { url: "/attendances/clock_out", method: "PATCH" }
        case "performance_update":
            return {
                url:    item.payload["_url"],
                method: item.payload["_method"]?.toUpperCase() || "PATCH"
            }
        case "photo_upload":
            return { url: "/attendances/upload_photo", method: "POST" }
        default:
            return { url: null, method: null }
    }
}

function buildFormData(payload, method) {
    const formData = new FormData()

    Object.entries(payload).forEach(([key, value]) => {
        if (key.startsWith("_")) return

        if (Array.isArray(value)) {
            value.forEach(v => formData.append(key, v))
        } else {
            formData.append(key, value)
        }
    })

    if (method === "PATCH") {
        formData.append("_method", "PATCH")
    }

    return formData
}